module.exports = __webpack_public_path__ + "media/images/icons/rarr_green-da9b4a062529debfaa77335d3647049c.svg";